document.addEventListener('DOMContentLoaded', function() {   
    
    const contactSlider = new Swiper(".banner__slider", {
        slidesPerView: 1,         
        scrollbar: {
        el: ".swiper-scrollbar",        
        }
     })
    
    const subproductsSlider = new Swiper(".subproducts-wrapper", {
        slidesPerView: 2.2,  
        breakpoints: {
            640: {
              slidesPerView: 2.2,              
            },           
            1024: {
              slidesPerView: 3.2,            
            },
          },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },  
        scrollbar: {
            el: ".swiper-scrollbar",        
        }  
    })

    const coliconsslider = new Swiper(".collection__icon-slider .swiper-slider", {
        slidesPerView: "auto",  
        spaceBetween: 14, 
        freeMode: true                 
    })
})